import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ebdf70a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "sidebarMenu",
  class: "col-md-3 col-lg-2 col-xxl-2 bg-xr-side-nav px-2 d-md-block sidebar collapse"
}
const _hoisted_2 = { class: "inline-block user-name" }
const _hoisted_3 = { class: "inline-block relative border-2 border-gray-text rounded-full w-11 bottom-0 h-11 left-0 p-1" }
const _hoisted_4 = {
  key: 1,
  class: "nav-link disabled",
  style: {"color":"#6c757d !important"}
}
const _hoisted_5 = {
  key: 0,
  class: "text-gray-text uppercase px-6 mt-4 mb-1"
}
const _hoisted_6 = {
  key: 1,
  class: "text-gray-text uppercase px-6 mt-4 mb-1"
}
const _hoisted_7 = { class: "text-white p-0 block tablet:hidden" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text uppercase px-6 mt-4 mb-1" }, "Create", -1))
const _hoisted_9 = { class: "list-unstyled" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-game inline-block mr-5" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Start creating games ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-token inline-block mr-5" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Add new tokens ")
const _hoisted_15 = { class: "block tablet:hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name : 'viewAccount' },
      class: "mb-1 flex tablet:hidden user-nav-link mt-20 md:mt-0",
      onClick: _ctx.setDropDown
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.username), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "bg-cover bg-center bg-black-body w-full h-full rounded-full",
            style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
          }, null, 4)
        ])
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
      return (_openBlock(), _createElementBlock("ul", {
        key: item.id,
        class: "text-white p-0"
      }, [
        _createElementVNode("li", {
          class: _normalizeClass([{'activeMenu' : this.$route.name == item.name}, {'list-unstyled-disabled' : (item.id === 5 || item.id === 6)}, {'list-unstyled' : (item.id != 5 && item.id != 6)} ])
        }, [
          (item.id !== 5 && item.id !== 6)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.route,
                class: "nav-link w-full",
                onClick: _ctx.setDropDown
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([item.icon, "inline-block mr-5"])
                  }, null, 2),
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            : _createCommentVNode("", true),
          (item.id === 5 || item.id === 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass([item.icon, "inline-block mr-5"])
                }, null, 2),
                _createTextVNode(_toDisplayString(item.label), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (item.id==1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "MANAGE"))
          : _createCommentVNode("", true),
        (item.id==3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "ADMIN"))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("ul", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("a", {
          href: "#",
          class: "nav-link w-full",
          onClick: [
            _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setDropDown && _ctx.setDropDown(...args))),
            _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createNewGame && _ctx.createNewGame(...args)), ["prevent"]))
          ]
        }, _hoisted_12)
      ]),
      _createElementVNode("li", {
        class: _normalizeClass(["list-unstyled", {'activeMenu' : this.$route.name == 'viewTokensCreate'}])
      }, [
        _createVNode(_component_router_link, {
          to: { name: 'viewTokensCreate', params: { network: 'testnet' } },
          class: "nav-link w-full",
          onClick: _ctx.setDropDown
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("a", {
        href: "#",
        onClick: [
          _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
          _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setDropDown && _ctx.setDropDown(...args)))
        ],
        class: "w-full nav-link text-white hover:underline"
      }, "Sign Out")
    ])
  ]))
}